import types from '../constants/types'

export const commonMutation = {
  [types.COMMON_REQUEST] (state, action) {
    state[action.request] = {...state[action.request]}
  },
  [types.COMMON_SUCCESS] (state, action) {
    state[action.request] = {...state[action.request]}
    state[action.request]['data'] = action.data.data || action.data.info
  },
  [types.COMMON_FAILURE] (state, action) {
    state[action.request] = {...state[action.request]}
  },
  [types.COMMON_INIT] (state, action) {
    state[action.request] = {...state[action.request]}
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/common.js